module.exports = "app-navbar, #navbar{\r\n  z-index: 2;\r\n  width: 100%;\r\n  height: 40px;\r\n  border-bottom: 1px solid seagreen;\r\n  position: absolute;\r\n  left:0;\r\n  right: 0;\r\n  top: 0;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/navbar/navbar.component.css
// module id = ./src/app/components/header/navbar/navbar.component.css
// module chunks = main